const Skill = [
  {
    name: "C++",
    value: 70,
  },
  {
    name: "HTML & CSS",
    value: 80,
  },
  {
    name: "JAVASCRIPT",
    value: 70,
  },
  {
    name: "REACT Js",
    value: 85,
  },
  {
    name: "DSA",
    value: 90,
  },
];

export default Skill;
